import * as React from "react";
import { t } from "i18next";
import { PlusCircleFilled } from "@ant-design/icons";
import { Button, Drawer, Input, Space } from "antd";
import { KeepSelected } from "src/components/tables/KeepSelected";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";
import { ZUid } from "src/types/zUid";
import { observer } from "mobx-react-lite";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { ZEntity } from "src/types/ZEntity";
import styles from "./SelectSizeLine.module.less";

interface PropsSelectSizeLine {
  objSizeLineId: ZUid;
  sizeLineAttrNameId: ZUid;
  value?: string;
  sizeLineName: string;
  onChange?(newValue: ZUid | null): void;
  onChangeName?(sizeLineName: string): void;
  disabled?: boolean;
  optional?: boolean;
}

export const SelectSizeLine: React.FC<PropsSelectSizeLine> = observer(
  (props) => {
    const {
      objSizeLineId,
      sizeLineAttrNameId,
      value,
      sizeLineName,
      onChange,
      onChangeName,
      disabled,
      optional,
    } = props;
    const [open, setOpen] = React.useState(false);
    const close = () => setOpen(false);
    const handleOk = () => {
      const selected = getSelectedRow();
      if (selected) {
        onChange?.(selected.id);
        onChangeName?.(makeTag(selected));
      } else {
        onChange?.(null);
        onChangeName?.("");
      }
      close();
    };
    const label = "Размерный ряд";
    const filtersPageStore = React.useMemo(
      () =>
        new EntityFiltersPageStore({
          objectId: objSizeLineId,
          selectionSettings: {
            keepSelected: true,
            selectionType: "radio",
          },
          onRowClick(row) {
            const store = filtersPageStore?.tableStore;
            if (store) selectOnRowClick(row, store);
          },
          actions: new Set(),
        }),
      [],
    );
    React.useEffect(() => {
      // Имитация выбранной строки. Формируется из value и sizeLineName
      filtersPageStore.tableStore?.setSelected(
        value
          ? [
              {
                id: value,
                attributeValues: [
                  {
                    attributeId: sizeLineAttrNameId,
                    values: [sizeLineName],
                  },
                ],
              } as ZEntityRow,
            ]
          : [],
      );
    }, [value]);
    const getSelectedRow = (): ZEntityRow | undefined =>
      filtersPageStore.tableStore?.selected[0];

    const { tableStore } = filtersPageStore;
    const makeTag = (row: ZEntityRow): string => {
      const entity = row as ZEntity;

      const a = entity.attributeValues?.find(
        ({ attributeId }) => attributeId === sizeLineAttrNameId,
      );
      return a?.values?.[0] ?? String(row.id);
    };

    return (
      <>
        <Input
          readOnly
          disabled={disabled}
          placeholder="Выбрать"
          suffix={<PlusCircleFilled className={styles.icon} />}
          onClick={() => {
            if (!disabled) setOpen(true);
          }}
          className={styles.input}
          value={sizeLineName}
        />
        <Drawer
          width="75vw"
          open={open && !disabled}
          onClose={close}
          className={styles.drawer}
          title={label}
          extra={
            <Space>
              <Button onClick={close}>{t("Cancel")}</Button>
              <Button
                type="primary"
                onClick={handleOk}
                disabled={!optional && !getSelectedRow()}
              >
                {t("Save")}
              </Button>
            </Space>
          }
        >
          <div className={styles.drawerContent}>
            {tableStore && makeTag && (
              <KeepSelected
                store={tableStore}
                makeTag={(row) => makeTag(row)}
                placeholder={t("Selected positions")}
              />
            )}
            <EntityFiltersTable
              store={filtersPageStore}
              // statesLoader={statesLoader}
            />
          </div>
        </Drawer>
      </>
    );
  },
);
